module.exports = __webpack_public_path__ + "static/media/mysql.2efce06f.png";